import { fetchWithAuth } from './api';

const host = window.location.hostname === 'localhost' ? "http://localhost:8000/api" : "/api";

// Chat API functions for Sidebar chat component
export async function streamChatMessage(
    messages: Array<{ role: string; content: string }>,
    abortSignal?: AbortSignal,
): Promise<Response> {
    try {
        const contractId = 78;
        const response = await fetchWithAuth(host + "/chat/llama/generate", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                messages: messages.map(msg => ({ ...msg, contract_ids: [contractId] })),
                contract_workspace_ids: [contractId],
            }),
            signal: abortSignal,
        });
        return response;
    } catch (error) {
        console.error("Error in chat stream API:", error);
        throw error;
    }
}

export async function getChatHistory(): Promise<any> {
    try {
        const response = await fetchWithAuth(host + "/chat/history", {
            method: "GET",
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching chat history:", error);
        return null;
    }
}

export async function saveChatMessage(
    message: string,
    role: string,
    chatId?: string
): Promise<any> {
    try {
        const response = await fetchWithAuth(host + "/chat/message", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                message,
                role,
                chat_id: chatId,
            }),
        });
        return await response.json();
    } catch (error) {
        console.error("Error saving chat message:", error);
        return null;
    }
}
